import type {Inventory} from '@/redux/v1/models';
import type {ApiError} from '@travel-frontend/state-handling-sdk';

export const FETCH_INVENTORY = 'v1/offers/inventory/FETCH_INVENTORY';

type FetchInventoryMeta = {
  hotelId: string;
  requestId: string;
};

export type FetchInventoryResult = {
  unfiltered: Inventory;
  filtered: Inventory;
  translations: Record<string, string>;
};

export type FetchInventoryPending = {meta: FetchInventoryMeta};

export type FetchInventorySuccess = {
  data: FetchInventoryResult;
  meta: FetchInventoryMeta;
};

export type FetchInventoryError = ApiError<unknown, {meta: FetchInventoryMeta}>;
